// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.top-bar-green {
    border-top: 5px solid rgb(10, 103, 38);
}
.top-bar-green-thin {
    border-top: 2px solid rgb(10, 103, 38);
}

.top-bar-red {
    border-top: 5px solid rgb(128, 39, 39);
}

.top-bar-gold {
    border-top: 5px solid goldenrod;
}

.bold-text {
    font-size: 20px
}

.bk-green {
    background-color: darkseagreen
}

.btn-red {
    background-color: rgb(128, 39, 39);
    color: white;
    border: rgb(28, 1, 1);
}

.btn-red:hover {
    background-color: rgb(177, 67, 67);
}

.custom-btn {
    background-color: #44c6ee;
  transition: background-color 0.3s ease; /* Transition for background color and text color */
}

.custom-btn:hover {
    color: black;
  background-color: #bcd6f3; /* Light blue background on hover */
}

.custom-bg-color {
  background-color: #046688; /* Your custom background color */
}



.btn-blue {
    background-color: rgb(26, 115, 203);
    color: white;
    border: rgb(28, 1, 1);
}

.btn-blue:hover {
    background-color: rgb(121, 169, 241);
}

.listItem {
    list-style-type: none;
    border-bottom: 1px solid black
}

.listItem:hover {
    background-color: white;
}

.link-text {
    font-size: 15px;
    font-weight: bold;
}

/* Basic styling for the navigation container */
/*.sidebar {*/
/*    background-color: #f8f9fa; !* Light background color *!*/
/*}*/
.logo {
    max-height: 50px;
}

@media screen and (min-width: 992px) {
    .sidebar {
        padding-top: 20px;
        position: sticky;
        top: 0;
        height: 400px;
        overflow-y: auto;
    }

    .image-fix {
        height: 500px;
    }

    .table-link {
        max-width: 300px
    }
}

@media screen and (max-width: 991px) {
    .sidebar {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .bold-text {
        font-size: 18px;
    }

    .image-fix {
        height: 300px;
    }

    .table-link {
        max-width: 200px
    }

    .table-source {
        min-width: 150px
    }
}

@media screen and (max-width: 768px) {
    .table-link {
        max-width: 150px
    }

    .table-source {
        min-width: 100px
    }
    .logo {
        max-height: 40px;
    }
}


@media screen and (max-width: 576px) {
    .logo {
        max-height: 30px;
    }
    .table-link {
        max-width: 100px
    }
}

/* Styling for headings */
.sidebar h2 {
    color: #333; /* Dark color for headings */
    padding: 10px;
    font-size: 1.2em;
}

.hover-underline:hover {
    text-decoration: underline;
}

/* Styling for the links */
.sidebar ul {
    list-style-type: none;
}

.sidebar li {
    margin: 5px 0;
}
/* new side bar styling */
.sideline {
    border-right: 1px solid #ccc;
}

.sidebar1 {
    position: sticky;
    top: 0;
    width: 350px;
    height: 100vh;
    border-right: 1px solid #ccc;
    overflow-y: auto;
    padding: 20px;
}

.sidebar1-section {
    margin-bottom: 20px; /* Add space between sections */
}

.sidebar1-header {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px; /* Add space below header */
}

.sidebar1-line {
    border-bottom: 1px solid #ccc; /* Add line under header */
    margin-bottom: 10px; /* Adjust spacing */
}

.sidebar1-content ul {
    list-style-type: none;
    padding-left: 20px;
}

.sidebar1-content ul li {
    margin-bottom: 5px; /* Add space between list items */
}

.item-box {
    overflow-y: hidden;
}






`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;EAC3B,sCAAsC,EAAE,mDAAmD;AAC7F;;AAEA;IACI,YAAY;EACd,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;;;AAIA;IACI,mCAAmC;IACnC,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,+CAA+C;AAC/C,aAAa;AACb,8DAA8D;AAC9D,IAAI;AACJ;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,MAAM;QACN,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;IACA;QACI,gBAAgB;IACpB;AACJ;;;AAGA;IACI;QACI,gBAAgB;IACpB;IACA;QACI;IACJ;AACJ;;AAEA,yBAAyB;AACzB;IACI,WAAW,EAAE,4BAA4B;IACzC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,0BAA0B;AAC1B;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;AACA,yBAAyB;AACzB;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB,EAAE,+BAA+B;AACxD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB,EAAE,2BAA2B;AACpD;;AAEA;IACI,6BAA6B,EAAE,0BAA0B;IACzD,mBAAmB,EAAE,mBAAmB;AAC5C;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB,EAAE,iCAAiC;AACzD;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["\n.top-bar-green {\n    border-top: 5px solid rgb(10, 103, 38);\n}\n.top-bar-green-thin {\n    border-top: 2px solid rgb(10, 103, 38);\n}\n\n.top-bar-red {\n    border-top: 5px solid rgb(128, 39, 39);\n}\n\n.top-bar-gold {\n    border-top: 5px solid goldenrod;\n}\n\n.bold-text {\n    font-size: 20px\n}\n\n.bk-green {\n    background-color: darkseagreen\n}\n\n.btn-red {\n    background-color: rgb(128, 39, 39);\n    color: white;\n    border: rgb(28, 1, 1);\n}\n\n.btn-red:hover {\n    background-color: rgb(177, 67, 67);\n}\n\n.custom-btn {\n    background-color: #44c6ee;\n  transition: background-color 0.3s ease; /* Transition for background color and text color */\n}\n\n.custom-btn:hover {\n    color: black;\n  background-color: #bcd6f3; /* Light blue background on hover */\n}\n\n.custom-bg-color {\n  background-color: #046688; /* Your custom background color */\n}\n\n\n\n.btn-blue {\n    background-color: rgb(26, 115, 203);\n    color: white;\n    border: rgb(28, 1, 1);\n}\n\n.btn-blue:hover {\n    background-color: rgb(121, 169, 241);\n}\n\n.listItem {\n    list-style-type: none;\n    border-bottom: 1px solid black\n}\n\n.listItem:hover {\n    background-color: white;\n}\n\n.link-text {\n    font-size: 15px;\n    font-weight: bold;\n}\n\n/* Basic styling for the navigation container */\n/*.sidebar {*/\n/*    background-color: #f8f9fa; !* Light background color *!*/\n/*}*/\n.logo {\n    max-height: 50px;\n}\n\n@media screen and (min-width: 992px) {\n    .sidebar {\n        padding-top: 20px;\n        position: sticky;\n        top: 0;\n        height: 400px;\n        overflow-y: auto;\n    }\n\n    .image-fix {\n        height: 500px;\n    }\n\n    .table-link {\n        max-width: 300px\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .sidebar {\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n\n    .bold-text {\n        font-size: 18px;\n    }\n\n    .image-fix {\n        height: 300px;\n    }\n\n    .table-link {\n        max-width: 200px\n    }\n\n    .table-source {\n        min-width: 150px\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .table-link {\n        max-width: 150px\n    }\n\n    .table-source {\n        min-width: 100px\n    }\n    .logo {\n        max-height: 40px;\n    }\n}\n\n\n@media screen and (max-width: 576px) {\n    .logo {\n        max-height: 30px;\n    }\n    .table-link {\n        max-width: 100px\n    }\n}\n\n/* Styling for headings */\n.sidebar h2 {\n    color: #333; /* Dark color for headings */\n    padding: 10px;\n    font-size: 1.2em;\n}\n\n.hover-underline:hover {\n    text-decoration: underline;\n}\n\n/* Styling for the links */\n.sidebar ul {\n    list-style-type: none;\n}\n\n.sidebar li {\n    margin: 5px 0;\n}\n/* new side bar styling */\n.sideline {\n    border-right: 1px solid #ccc;\n}\n\n.sidebar1 {\n    position: sticky;\n    top: 0;\n    width: 350px;\n    height: 100vh;\n    border-right: 1px solid #ccc;\n    overflow-y: auto;\n    padding: 20px;\n}\n\n.sidebar1-section {\n    margin-bottom: 20px; /* Add space between sections */\n}\n\n.sidebar1-header {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px; /* Add space below header */\n}\n\n.sidebar1-line {\n    border-bottom: 1px solid #ccc; /* Add line under header */\n    margin-bottom: 10px; /* Adjust spacing */\n}\n\n.sidebar1-content ul {\n    list-style-type: none;\n    padding-left: 20px;\n}\n\n.sidebar1-content ul li {\n    margin-bottom: 5px; /* Add space between list items */\n}\n\n.item-box {\n    overflow-y: hidden;\n}\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
